var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257,
    height: 238,
    viewBox: "0 0 257 238",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.1 0.5L143.6 74.4L162 30.8L243.1 0.5Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 0.5L112.1 75.1L94.6 30.8L13.4 0.5ZM207.3 171.8L180.8 212.4L237.5 228L253.8 172.7L207.3 171.8ZM2.90002 172.7L19.1 228L75.8 212.4L49.3 171.8L2.90002 172.7Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6 103.2L56.8 127.1L113.1 129.6L111.1 69.1L72.6 103.2ZM183.9 103.2L144.9 68.4L143.6 129.6L199.8 127.1L183.9 103.2ZM75.8 212.4L109.6 195.9L80.4 173.1L75.8 212.4ZM146.9 195.9L180.8 212.4L176.1 173.1L146.9 195.9Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.8 212.4L146.9 195.9L149.6 218L149.3 227.3L180.8 212.4ZM75.8 212.4L107.3 227.3L107.1 218L109.6 195.9L75.8 212.4Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 158.5L79.6 150.2L99.5 141.1L107.8 158.5ZM148.7 158.5L157 141.1L177 150.2L148.7 158.5Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8 212.4L80.6 171.8L49.3 172.7L75.8 212.4ZM176 171.8L180.8 212.4L207.3 172.7L176 171.8ZM199.8 127.1L143.6 129.6L148.8 158.5L157.1 141.1L177.1 150.2L199.8 127.1ZM79.6 150.2L99.6 141.1L107.8 158.5L113.1 129.6L56.8 127.1L79.6 150.2Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8 127.1L80.4 173.1L79.6 150.2L56.8 127.1ZM177.1 150.2L176.1 173.1L199.8 127.1L177.1 150.2ZM113.1 129.6L107.8 158.5L114.4 192.6L115.9 147.7L113.1 129.6ZM143.6 129.6L140.9 147.6L142.1 192.6L148.8 158.5L143.6 129.6Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8 158.5L142.1 192.6L146.9 195.9L176.1 173.1L177.1 150.2L148.8 158.5ZM79.6 150.2L80.4 173.1L109.6 195.9L114.4 192.6L107.8 158.5L79.6 150.2Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.3 227.3L149.6 218L147.1 215.8H109.4L107.1 218L107.3 227.3L75.8 212.4L86.8 221.4L109.1 236.9H147.4L169.8 221.4L180.8 212.4L149.3 227.3Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 195.9L142.1 192.6H114.4L109.6 195.9L107.1 218L109.4 215.8H147.1L149.6 218L146.9 195.9Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.3 79.2L255.8 38.4L243.1 0.5L146.9 71.9L183.9 103.2L236.2 118.5L247.8 105L242.8 101.4L250.8 94.1L244.6 89.3L252.6 83.2L247.3 79.2ZM0.799988 38.4L9.29999 79.2L3.89999 83.2L11.9 89.3L5.79999 94.1L13.8 101.4L8.79999 105L20.3 118.5L72.6 103.2L109.6 71.9L13.4 0.5L0.799988 38.4Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236.2 118.5L183.9 103.2L199.8 127.1L176.1 173.1L207.3 172.7H253.8L236.2 118.5ZM72.6 103.2L20.3 118.5L2.90002 172.7H49.3L80.4 173.1L56.8 127.1L72.6 103.2ZM143.6 129.6L146.9 71.9L162.1 30.8H94.6L109.6 71.9L113.1 129.6L114.3 147.8L114.4 192.6H142.1L142.3 147.8L143.6 129.6Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.7a173b3be579b444ca1be9b5410f456f.svg";
export { ForwardRef as ReactComponent };